export function parseQueryParams (queryString) {
  if (queryString == null) {
    return {}
  }

  const pairString = queryString[0] === '?' ? queryString.substr(1) : queryString
  if (pairString.length === 0) {
    return {}
  }

  const pairs = pairString.split('&').map(decodeURIComponent)
  return pairs.reduce((acc, pair) => {
    // If there is a trailing ampersand do not parse it
    if (!pair) {
      return acc
    }

    let arrayValue = false
    let [key, value] = pair.split('=')

    if (key.substr(-2) === '[]') {
      arrayValue = true
      key = key.substr(0, key.length - 2)
    }

    value = value || true

    if (!arrayValue && acc[key] === undefined) {
      acc[key] = value
      return acc
    }

    // At this point we have aray values either because key is present more than once
    // or key ends with []
    if (!Array.isArray(acc[key])) {
      const previousValue = acc[key]
      acc[key] = []
      if (previousValue !== undefined) {
        acc[key].push(previousValue)
      }
    }

    acc[key].push(value)
    return acc
  }, {})
}

export function constructUrl (queryString) {
  queryString = queryString || ''
  if (queryString.indexOf('?') !== 0) {
    queryString = `?${queryString}`
  }

  const wl = window.location
  return `${wl.protocol}//${wl.host}${wl.pathname}${queryString}${wl.hash}`
}

export function scrollToAnchor () {
  const hash = window.location.hash
  if (!hash) {
    return
  }

  const target = document.querySelector(hash)
  if (!target) {
    return
  }

  window.scrollTo(0, target.getBoundingClientRect().y + window.pageYOffset)
}

const isLocalStorageAvailable = () => {
  try {
    const keyValue = '__storage_test__'

    window.localStorage.setItem(keyValue, keyValue)
    window.localStorage.removeItem(keyValue)

    return true
  } catch (e) {
    return (
      window.localStorage &&
      window.localStorage.length !== 0 &&
      e instanceof DOMException &&
      // everything except Firefox
      (e.code === 22 ||
        // Firefox
        e.code === 1014 ||
        // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' ||
        // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED')
    )
  }
}

export const LocalStorage = {
  getItem(key) {
    if (!isLocalStorageAvailable()) {
      return null
    }

    return JSON.parse(window.localStorage.getItem(key))
  },

  setItem(key, value) {
    if (!isLocalStorageAvailable()) {
      return
    }

    window.localStorage.setItem(key, JSON.stringify(value))
  },
}
